import get from "lodash-es/get";
import defaultTranslations from "./translations";

export class TranslationService {
  private _timeout = 1000;
  private readonly _ui: any;
  private readonly _defaults: any;
  private _translations: any;

  static create() {
    return new TranslationService((window as any).e, defaultTranslations);
  }

  constructor(ui, defaults) {
    this._ui = ui;
    this._defaults = defaults;
  }

  get(key) {
    return get(this._translations, key) || get(this._defaults, key);
  }

  async fetch() {
    if (this._translations) {
      return;
    }

    this._translations = await Promise.race([
      this._ui.utils
        .getTranslation("ui-framework-order")
        .then((response) => response["ui-framework-order"]),
      new Promise((resolve) => setTimeout(() => resolve(this._defaults), this._timeout)),
    ]).catch(() => this._defaults);
  }
}
